export default "<div class=\"kt-portlet\" [ngClass]=\"class\" #portlet>\n\t<ng-content></ng-content>\n</div>\n"